import { useEffect, useRef, useState } from 'react';
import {
  Button,
  ButtonGroup,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Container,
  Input,
  SelectDropdown,
  Col,
  Row,
  CloseButton,
  Grid,
  Card,
} from '@uhg-uicl/ui-core/dist';
import { ColumnType } from '@uhg-uicl/ui-core/dist/Organisms/Grid/types';
import axios from 'axios';
import { useMsal } from '@azure/msal-react';

interface Props {
  isOpen?: boolean; // Expect a boolean for the initial state
  setIsOpen?: (isOpen: boolean) => void; // Function to update the state
  rrdInventoryItem: any;
  setRRdInventoryItem: any;
  refreshData: any;
}

function RRDInventoryDetailsViewModal({ isOpen = false, setIsOpen = () => { }, rrdInventoryItem, setRRdInventoryItem, refreshData }: Props) {

    const [gridRecords, setGridRecords] = useState<{ id: number; documentType: string; fileName: string }[]>([]);

    const { accounts } = useMsal();
    const userdetails = JSON.parse(localStorage.getItem('userdetails') || '');
    const userid = userdetails[0].portal_Id != '' ? userdetails[0].portal_Id : accounts[0].username;

    useEffect(() => {
        if (rrdInventoryItem?.inventoryFiles && Array.isArray(rrdInventoryItem.inventoryFiles)) {
            const files = rrdInventoryItem.inventoryFiles.map((file: any, idx: number) => ({
                id: file.inventoryFileId,
                documentType: file.documentType,
                fileName: file.fileName,
                // add other fields if needed
            }));
            setGridRecords(files);
        } else {
            setGridRecords([]);
        }
    }, [rrdInventoryItem]);

    const transactionStatusTypes: { [key: string]: string } = {
    "1": "New",
    "2": "File Uploaded",
    "3": "Packaging",
    "4": "ECGReady",
    "5": "ValidationCompleted",
    "6": "ECGPending",
    "7": "ECGCompleted",
    "8": "Failed"
  };

    // Function to get value by key
  function getPackageAbbreviation(key: string): string | undefined {
    return transactionStatusTypes[key];
  }

      const columns = new Set<ColumnType>([
        { dataName: 'documentType', text: 'Document Type', sortable: true, isSorted: 0 },
        { dataName: 'fileName', text: 'File Name', sortable: true, isSorted: 0 },
      ]);

    
    const updateTransactionStatus = async () => {
        if (!rrdInventoryItem?.inventoryMasterId) {
          return;
        }

        try {
        //   const tokenurl = process.env.REACT_APP_RRD_OPTIMIZATION_TOKEN_URL as string;
          const baseurl = process.env.REACT_APP_RRD_OPTIMIZATION_BASE_URL as string;

            const payload = {
                inventoryMasterId: rrdInventoryItem?.inventoryMasterId,
                transactionStatus: 2,
                componentName: "File Uploaded",
                componentStatus: '',
                remarks: "Inventory sent for reprocessing",
                modifiedBy: userid
            }

        //   const getToken = await axios.get(tokenurl);

        //   if (!getToken.data.success) { return; }

          const url = `${baseurl}/Inventory/UpdateStatus`;
          const formsResponse = await axios.put(url, payload, {
            headers: {
              accept: 'text/plain'
            },
          });
          if (formsResponse.data.success) {  
            refreshData(); 
              const inventoryResponse = await axios.get(`${baseurl}/Inventory/${rrdInventoryItem?.transactionId}`, {
                  headers: {
                      'Content-Type': 'application/json'
                  },
              });
              if (inventoryResponse.data.success) {
                setRRdInventoryItem(inventoryResponse.data.result);
              }
          } else {
            throw new Error('Failed to fetch forms');
          }
        } catch (error) {
          console.error('Error fetching forms:', error);
        }
      };

  return (
      <div>
          <Modal
              dataTestId="RRDModal-modalHeader"
              isOpen={isOpen} // Modal visibility controlled by isOpen prop
              onClickOut={() => setIsOpen(false)} // Close modal when clicking outside
              size="large"
              domID="RRD-modal"
              closeModalOnClickOut={true}
          >
              <ModalHeader
                  title="View Inventory Details"
                  dataTestId="test-header"
                //   description="Click cancel to close this modal."
                  onClose={() => setIsOpen(false)} // Close modal when clicking the close button
              />
              <ModalBody>
                  <Container>
                      <div style={{marginRight:'-10px', marginLeft:'-10px'}}>
                          <Row style={{margin:'0px 0px 8px'}}>
                              <Col sm={6}>
                                  <span style={{ fontWeight: 'bold', marginRight: '8px' }}>Client Name:</span>
                                  <span>{rrdInventoryItem?.clientName}</span>
                              </Col>
                              <Col sm={6}>
                                  <span style={{ fontWeight: 'bold', marginRight: '8px' }}>Region:</span>
                                  <span>{rrdInventoryItem?.region}</span>
                              </Col>
                          </Row>
                          <hr style={{ border: 'none', borderTop: '1px solid #e0e0e0', margin: '4px 0' }} />
                          <Row style={{margin:'0px 0px 8px'}}>
                              <Col sm={6}>
                                  <span style={{ fontWeight: 'bold', marginRight: '8px' }}>Facility Name:</span>
                                  <span>{rrdInventoryItem.senderInformation?.name}</span>
                              </Col>
                              <Col sm={6}>
                                  <span style={{ fontWeight: 'bold', marginRight: '8px' }}>Facility Address:</span>
                                  <span>{[rrdInventoryItem.senderInformation?.address
                                    , rrdInventoryItem.senderInformation?.city
                                    , rrdInventoryItem.senderInformation?.state
                                    , rrdInventoryItem.senderInformation?.zip].filter(Boolean).join(', ')}</span>
                              </Col>
                          </Row>
                          <hr style={{ border: 'none', borderTop: '1px solid #e0e0e0', margin: '4px 0' }} />
                          <Row style={{margin:'0px 0px 8px'}}>
                              <Col sm={6}>
                                  <span style={{ fontWeight: 'bold', marginRight: '8px' }}>Account No:</span>
                                  <span>{rrdInventoryItem.claimInformation?.accountNumber}</span>
                              </Col>
                              <Col sm={6}>
                                  <span style={{ fontWeight: 'bold', marginRight: '8px' }}>MRN:</span>
                                  <span>{rrdInventoryItem.claimInformation?.mrn}</span>
                              </Col>
                          </Row>
                          <hr style={{ border: 'none', borderTop: '1px solid #e0e0e0', margin: '4px 0' }} />
                          <Row style={{margin:'0px 0px 8px'}}>
                              <Col sm={6}>
                                  <span style={{ fontWeight: 'bold', marginRight: '8px' }}>Request Type:</span>
                                  <span>{rrdInventoryItem?.requestType}</span>
                              </Col>
                              <Col sm={6}>
                                  <span style={{ fontWeight: 'bold', marginRight: '8px' }}>{rrdInventoryItem?.requestType} Name:</span>
                                  <span>{rrdInventoryItem.receiverInformation?.name}</span>
                              </Col>
                          </Row>
                          <hr style={{ border: 'none', borderTop: '1px solid #e0e0e0', margin: '4px 0' }} />
                          <Row style={{margin:'0px 0px 8px'}}>
                            <Col sm={6}>
                                  <span style={{ fontWeight: 'bold', marginRight: '8px' }}>{rrdInventoryItem?.requestType} Address:</span>
                                  <span>{[rrdInventoryItem.receiverInformation?.address
                                    , rrdInventoryItem.receiverInformation?.city
                                    , rrdInventoryItem.receiverInformation?.state
                                    , rrdInventoryItem.receiverInformation?.zip].filter(Boolean).join(', ')}</span>
                              </Col>
                              <Col sm={6}>
                                  <span style={{ fontWeight: 'bold', marginRight: '8px' }}>Created By:</span>
                                  <span>{rrdInventoryItem?.createdBy}</span>
                              </Col>                              
                          </Row>
                          <hr style={{ border: 'none', borderTop: '1px solid #e0e0e0', margin: '4px 0' }} />                           
                           <Row style={{margin:'0px 0px 8px'}}>
                              <Col sm={6}>
                                  <span style={{ fontWeight: 'bold', marginRight: '8px' }}>Package Name:</span>
                                  <span>{rrdInventoryItem?.packageName}</span>
                              </Col>
                              <Col sm={6}>
                                  <span style={{ fontWeight: 'bold', marginRight: '8px' }}>Batch Name:</span>
                                  <span>{rrdInventoryItem?.batchName}</span>
                              </Col>
                          </Row>
                          <hr style={{ border: 'none', borderTop: '1px solid #e0e0e0', margin: '4px 0' }} />
                          <Row style={{margin:'0px 0px 8px'}}>
                            <Col sm={6}>
                                  <span style={{ fontWeight: 'bold', marginRight: '8px' }}>Created On:</span>
                                  <span>
                                      {rrdInventoryItem?.createdOn
                                          ? (() => {
                                              const d = new Date(rrdInventoryItem.createdOn);
                                              let hour = d.getHours();
                                              const day = d.getDate();
                                              const month = d.toLocaleString('en-US', { month: 'short' });
                                              const year = d.getFullYear();
                                              const minute = String(d.getMinutes()).padStart(2, '0');
                                              const ampm = hour >= 12 ? 'PM' : 'AM';
                                              hour = hour % 12 || 12;
                                              return `${day} ${month} ${year} ${hour}:${minute} ${ampm}`;
                                          })()
                                          : ''}
                                  </span>
                              </Col>  
                              <Col sm={6}>
                                  <div style={{ display: 'flex', alignItems: 'center', gap: '2rem' }}>
                                      <div>
                                          <span style={{ fontWeight: 'bold', marginRight: '8px' }}>Exception:</span>
                                          <span>
                                              {rrdInventoryItem?.componentStatus === 'BE'
                                                  ? 'Business Exception'
                                                  : rrdInventoryItem?.componentStatus === 'SE'
                                                      ? 'Technical Exception'
                                                      : 'N/A'}
                                          </span>
                                      </div>
                                      {(rrdInventoryItem?.componentStatus === 'BE' || rrdInventoryItem?.componentStatus === 'SE') && (
                                          <Button buttonType="emphasized" name="ReNew" size="small" onClick={() => { updateTransactionStatus(); }}/>
                                      )}
                                  </div>
                              </Col>
                          </Row>
                          <hr style={{ border: 'none', borderTop: '1px solid #e0e0e0', margin: '4px 0' }} />
                          <Row style={{margin:'0px 0px 8px'}}>                              
                              <Col sm={6}>
                                  <span style={{ fontWeight: 'bold', marginRight: '8px' }}>Status:</span>
                                  <span>{getPackageAbbreviation(rrdInventoryItem?.transactionStatus)}</span>
                              </Col>
                              <Col sm={6}>
                                  <span style={{ fontWeight: 'bold', marginRight: '8px' }}>Remarks:</span>
                                  <span>{rrdInventoryItem?.remarks}</span>
                              </Col>
                          </Row>
                          <hr style={{ border: 'none', borderTop: '1px solid #e0e0e0', margin: '4px 0', paddingBottom:'2rem' }} />
                          {gridRecords.length > 0 &&<Card cardHeader={() => <span style={{marginLeft:'10px',fontWeight:'bold'}}>Files Uploaded</span>}>
                          <div style={{ width: '100%' }}>
                                  <Grid
                                      columns={new Set(columns)} // Convert array to Set
                                      dataTestId="test-gridDefault"
                                      domID="test-id"
                                      records={gridRecords}
                                      supportSelection={false}
                                      selectionKey="id" // Added selectionKey property
                                  />
                              </div>
                          </Card>}
                      </div>
                  </Container>
              </ModalBody>
              <ModalFooter>
                  <ButtonGroup>
                      <Button buttonType="diminished" name="Close" onClick={() => setIsOpen(false)} />
                  </ButtonGroup>
              </ModalFooter>
          </Modal>
      </div>
  );
}

export default RRDInventoryDetailsViewModal;